import { AIDesignParams } from '../class/export';
import { UPDATE_PARAMS } from '../constants';

export default function (state, action) {
  switch (action.type) {
    case UPDATE_PARAMS:
      return AIDesignParams.updateParams(state, action.params).updatedState;
    default:
      return state;
  }
}